import { KitchenRaw } from "@prmf/site-data";
import { useFetcher, useParams } from "@remix-run/react";
import { useEffect } from "react";
import { twJoin } from "tailwind-merge";

export default function PartsKeyTable() {
  const fetcher = useFetcher<{ kitchens: KitchenRaw[] }>();
  const { slug } = useParams();
  const isHandles = slug === "handles";
  useEffect(() => {
    if (!fetcher.data && fetcher.state === "idle") {
      fetcher.load("/kitchens");
    }
  }, [fetcher.data]);
  const kitchens = [...(fetcher.data?.kitchens || [])]
    .filter(
      (k) => k.priceGroup !== undefined || (isHandles && k.group === "HJ"),
    )
    .sort((a, b) =>
      (a.priceGroup || a.group).localeCompare(b.priceGroup || b.group),
    );
  const keys = isHandles
    ? kitchens.reduce<KitchenRaw[]>((groups, kitchen) => {
        const name = kitchen.name.replace(/ Shaker$/, "");
        const group = groups.find(
          (k) =>
            (k.priceGroup || k.group) === (kitchen.priceGroup || kitchen.group),
        );
        if (group) {
          group.name += `, ${name}`;
        } else {
          groups.push({ ...kitchen, name });
        }
        return groups;
      }, [])
    : kitchens;
  return (
    <aside className="my-2 max-w-lg space-y-4 text-xs">
      <h3 className="font-semibold">Key</h3>
      <ul
        className={
          isHandles ? "gap-2 space-y-2" : "gap-2 space-y-2 md:columns-2"
        }
      >
        {keys.map((k) => (
          <li
            key={k.slug}
            className="flex break-inside-avoid items-center gap-2"
          >
            <span
              className={twJoin(
                "grid h-6 w-6 shrink-0 place-items-center rounded-sm",
                "text-xs font-medium text-white",
              )}
              style={{ backgroundColor: k.accentColor }}
            >
              {isHandles ? k.priceGroup || k.group : k.group}
            </span>
            <strong>{k.name}</strong>
            {k.priceGroup && <span>Price Group – {k.priceGroup}</span>}
          </li>
        ))}
      </ul>
    </aside>
  );
}
